export class KPISetting {
  id?: number;
  indicators: string;
  rangeMeetBelow: number;
  rangeMeetExceed: number;
  scoringBelow: number;
  scoringMeet: number;
  scoringExceed: number;
  rangeBelowOperator: number;
  rangeExceedOperator: number;
}

export class ScorecardSettingModel {
  parents: string[];
  year: number;
  gsls?: string[];
  settings: KPISetting[];
}

export class ScorecardFilterModel {
  search: string;
  years: number[];
}

export const CONDITION = {
  1: '<',
  2: '<=',
  3: '>',
  4: '>='
};

export const ASSESSMENT = {
  RELATIONSHIP_ASSEMSSENT: 'Behaviors Assessment',
  PERFORMANCE_ASSEMSSENT: 'Performance Assessment'
};

export const KPI_FORMGROUP = {
  RELATION_COMPLIANCE_INTEGRITY: {
    key: 'RELATION_COMPLIANCE_INTEGRITY',
    name: 'Compliance & Integrity',
    maxScore: 85
  },
  RELATION_TECHNOLOGY_INNOVATION: {
    key: 'RELATION_TECHNOLOGY_INNOVATION',
    name: 'Drive Innovation',
    maxScore: 85
  },
  RELATION_RESPONSIVENESS: {
    key: 'RELATION_RESPONSIVENESS',
    name: 'Customer Focus',
    maxScore: 85
  },
  RELATION_SC_COMPETENCY_FOOTPRINT: {
    key: 'RELATION_SC_COMPETENCY_FOOTPRINT',
    name: 'Lean Mindset',
    maxScore: 85
  },
  RELATION_GE_FLEXIBILITY_SWITCH: {
    key: 'RELATION_GE_FLEXIBILITY_SWITCH',
    name: `GE's Flexibility to Switch`,
    maxScore: 85
  },
  PERFORM_TOTAL_QUALITY_SCORE: {
    key: 'PERFORM_TOTAL_QUALITY_SCORE',
    name: 'Total Quality Score',
    maxScore: 115
  },
  PERFORM_ESCAPING_DEFECTS: {
    key: 'PERFORM_ESCAPING_DEFECTS',
    name: 'Escaping Defects (NCR, PAC, COPQ)'
  },
  PERFORM_YOY_COST_OUT_SUPPLIER_PRICE: {
    key: 'PERFORM_YOY_COST_OUT_SUPPLIER_PRICE',
    name: 'YoY Cost Out % (Supplier Price)'
  },
  PERFORM_YOY_COST_OUT_PCO: {
    key: 'PERFORM_YOY_COST_OUT_PCO',
    name: 'YoY Cost Out % (PCO)',
    maxScore: 115
  },
  PERFORM_OTD_PROMISED_DATE: {
    key: 'PERFORM_OTD_PROMISED_DATE',
    name: 'OTD% (Promised Date)',
    maxScore: 115
  },
  PERFORM_OTD_PLAN_NEEDS: {
    key: 'PERFORM_OTD_PLAN_NEEDS',
    name: 'OTD% (Plan Needs)'
  },
  PERFORM_DATE_LATE_PROMISED_DATE: {
    key: 'PERFORM_DATE_LATE_PROMISED_DATE',
    name: 'Days Late (Promised Date)'
  },
  PERFORM_DATE_LATE_PLAN_NEEDS: {
    key: 'PERFORM_DATE_LATE_PLAN_NEEDS',
    name: 'Days Late (Plan Needs)'
  },
  PERFORM_PAYMENT_DATE_TARGET: {
    key: 'PERFORM_PAYMENT_DATE_TARGET',
    name: 'Payment Days vs Target',
    maxScore: 115
  },
  PERFORM_LEAD_TIME_TARGET: {
    key: 'PERFORM_LEAD_TIME_TARGET',
    name: 'Lead Time vs Target',
    maxScore: 115
  },
  PERFORM_SUSTAINABILITY: {
    key: 'PERFORM_SUSTAINABILITY',
    name: 'Sustainability Overall Score',
    maxScore: 115
  },
  PERFORM_GE_CORE_REQUIREMENT: {
    key: 'PERFORM_GE_CORE_REQUIREMENT',
    name: 'Environment Score'
  },
  PERFORM_CARBON_PERFORMANCE: {
    key: 'PERFORM_CARBON_PERFORMANCE',
    name: 'Carbon Performance Score'
  },
  PERFORM_OVERALL_ECO_VADIS: {
    key: 'PERFORM_OVERALL_ECO_VADIS',
    name: 'Ethics'
  },
  PERFORM_OVERALL_ECO_VADIS_DEVELOPMENT: {
    key: 'PERFORM_OVERALL_ECO_VADIS_DEVELOPMENT',
    name: 'Sustainable Procurement'
  },
  PERFORM_FINANCIAL_HEALTH_RATING: {
    key: 'PERFORM_FINANCIAL_HEALTH_RATING',
    name: 'Financial Health Rating',
    maxScore: 115
  },
  PERFORM_APQP4Wind: {
    key: 'PERFORM_APQP4Wind',
    name: 'APQP4Wind'
  },
  PERFORM_MAJOR_DISRUPTION: {
    key: 'PERFORM_MAJOR_DISRUPTION',
    name: 'Major Disruption'
  }
};